import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type {
  OpenAccountEarnRequestDto,
  OpenAccountInvestRequestDto,
  OpenAccountMarginRequestDto,
  OpenAccountResponseDto,
} from './types';

export const openAccountSpot = async () => {
  const request = () => apiClient.post('/accounts/create/spot');
  const response = await handleRequest<OpenAccountResponseDto>(request);
  return response.data;
};

export const openAccountInvest = async (args: OpenAccountInvestRequestDto) => {
  const request = () => apiClient.post('/accounts/create/invest', args);
  const response = await handleRequest<OpenAccountResponseDto>(request);
  return response.data;
};

export const openAccountMargin = async (args: OpenAccountMarginRequestDto) => {
  const request = () => apiClient.post('/accounts/create/margin', args);
  const response = await handleRequest<OpenAccountResponseDto>(request);
  return response.data;
};

export const openAccountEarn = async (args: OpenAccountEarnRequestDto) => {
  const request = () => apiClient.post('/accounts/create/earn', args);
  const response = await handleRequest<OpenAccountResponseDto>(request);
  return response.data;
};
